module.exports = __webpack_public_path__ + "static/img/图层64.e32ce56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层64.png
// module id = WcDU
// module chunks = 0